import { TGetItemFn, TSetItemFn, TRemoveItemFn, TSetLastVisitedItemFn } from '@/config/types'
import { PageName } from '@/enums/pageName'
import { getCommonItem, removeCommonItem, setCommonItem } from '@/utils/localStorage'

import { EXPERIMENT_NAME } from './pages/constants'
import { pagesOrder } from './pages/pageOrder'

export const setItem: TSetItemFn = (key, value) => {
  return setCommonItem(key, value, EXPERIMENT_NAME)
}

export const getItem: TGetItemFn = (key) => {
  return getCommonItem(key, EXPERIMENT_NAME)
}

export const removeItem: TRemoveItemFn = (key) => {
  return removeCommonItem(key, EXPERIMENT_NAME)
}

export const setLastVisitedItem: TSetLastVisitedItemFn = (pageName: PageName) => {
  const lastPage = getItem('lastActionPage') || ''
  const lastPageIndex = pagesOrder.indexOf(lastPage as PageName)
  const currentPageIndex = pagesOrder.indexOf(pageName) || -1
  if (lastPageIndex <= currentPageIndex) {
    setItem('lastActionPage', pageName)
  }
}
